import { render, staticRenderFns } from "./TrainingSeenButton.vue?vue&type=template&id=9f6af606"
import script from "./TrainingSeenButton.vue?vue&type=script&lang=js"
export * from "./TrainingSeenButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports